import { APP_NAME } from '@/lib/constants';

/** Fournisseur d'identité PASS utilisé pour la session. */
export type Provider = 'customers' | 'pros';

/**
 * Contenu de la clé `APP_NAME` du localStorage.
 *
 * Le jeton n'y est **pas** : il vit dans un cookie HttpOnly posé par le Pass. Cette entrée ne
 * porte que le drapeau de session et le contexte d'accueil renvoyé à la connexion.
 */
export interface Session {
    authenticated?: boolean;
    /** Jeton Bearer passé en query string aux pages `/frames/*` (auto-connexion en iframe). */
    token?: string;
    welcome?: {
        message_footer?: string | null;
        message_warning?: string | null;
        img_footer?: string | null;
    };
    id_whitelabel?: number | string;
    provider?: Provider;
    id_token?: string;
    /** Contexte de déconnexion du tenant Gravitee source, après une redirection cross-brand. */
    gravitee_logout?: {
        client_id: string;
        logout_url: string;
        id_token: string;
    };
}

/** Lecture à chaque appel : le stockage peut changer hors de React (autre onglet, OTT…). */
export const getSession = (): Session | null => {
    try {
        return JSON.parse(window.localStorage.getItem(APP_NAME) || 'null') as Session | null;
    } catch {
        return null;
    }
};

export const setSession = (session: Session): void => {
    localStorage.setItem(APP_NAME, JSON.stringify(session));
};

/** Fusionne des champs dans la session existante. */
export const updateSession = (patch: Partial<Session>): void => {
    setSession({ ...(getSession() ?? {}), ...patch });
};

export const clearSession = (): void => {
    localStorage.removeItem(APP_NAME);
};

export const getIsAuthenticated = (): boolean => getSession()?.authenticated ?? false;

/** Provider utilisé pour l'authentification (`customers` par défaut). */
export const getProvider = (): Provider => getSession()?.provider ?? 'customers';
